module.exports = __webpack_public_path__ + "img/link.73603ad5.svg";